import { toUpperFirstLetter } from './string.helpers'

const buildDownloadFileName = (tokenName, reportType) => {
  return `${tokenName}_${toUpperFirstLetter(reportType)}`
}

export { buildDownloadFileName }
